// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"442":"b58e2447","704":"25121c94"}[chunkId] + ".chunk.js";
};